const initialState = {
	data: [],
	total: 0,
	params: {},
	selectedCasinoProvider: {},
	sidebarOpen: false,
	sidebarStatus: 'add',
}

const casinoprovider = (state = initialState, action) => {
	switch (action.type) {
		case 'CASINOPROVIDER_GET_DATA':
			return {
				...state,
				data: action.data,
				total: action.total,
				params: action.params,
			}
		case 'CASINOPROVIDER_ADD_DATA':
			return {
				...state,
				data: [...state.data, action.data],
				total: state.total + 1,
			}
		case 'CASINOPROVIDER_UPDATE_DATA':
			return {
				...state,
				data: state.data.map((item) => (item.id === action.index ? action.data : item)),
			}
		case 'CASINOPROVIDER_DEL_DATA':
			return {
				...state,
				data: state.data.filter((item) => item.id !== action.index),
				total: state.total - 1,
			}
		case 'CASINOPROVIDER_GET_CURRENT':
			return {
				...state,
				selectedCasinoProvider: action.selectedCasinoProvider,
			}
		case 'CASINOPROVIDER_SET_SIDEBAR':
			return {
				...state,
				sidebarStatus: action.status,
				sidebarOpen: !state.sidebarOpen,
			}
		default:
			return state
	}
}

export default casinoprovider
